import { default as deserialize } from 'app/utils/deserialize'
import { create } from 'app/utils/data'
import FormErrors from 'app/utils/form_errors'

export default {
  namespaced: true,

  state: {
    hasCard: true
  },

  getters: {
    sendToBillingPortal: (state) => !state.hasCard
  },

  mutations: {
    resetState: (state) => state,

    fetched(state, data) {
      state.hasCard = data.hasCard
    }
  },

  actions: {
    async requestBillingPortal(_state, _data) {
      try {
        const response = await create({
          url: '/api/billing-portal/session',
          type: 'billing-portal-session',
          data: {}
        })

        return await deserialize(response.data)
      } catch (error) {
        throw new FormErrors(error.response.data.errors)
      }
    },

    async billingPortalCustomer({ commit }, _data) {
      try {
        const response = await create({
          url: '/api/billing-portal/customer',
          type: 'billing-portal-customer',
          data: {}
        })

        const customerData = await deserialize(response.data)

        commit('fetched', customerData)

        return customerData
      } catch (error) {
        throw new FormErrors(error.response.data.errors)
      }
    }
  }
}
